import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const UserPreferences = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/user-preferences/components/UserPreferencesContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default UserPreferences;
